import React from 'react';
import { Provider } from 'react-redux';

import { ThemeProvider } from '@creditas/stylitas';
import tokens from '@creditas/tokens';

import { PersonalFormStore } from '../redux/store';
import { TrackingProvider } from '../../shared/utilities/tagManager/tagManager.hook';
import { tracking } from '../../shared/utilities/tagManager/tagManager.utils';

import Messages from '../utils/Message/containers/message.container';
import PersonalInfo from '../modules/personalInfo/containers/form/form.container';

import Listen from '../utils/eventManager/eventListen';
import { Events, Types } from '../utils/eventManager/events.types';
import { backInitialState } from '../modules/personalInfo/redux/personalInfo.actions';

interface PersonPageProps {
  goTo: string;
}

const mfPersonPage: React.FC<PersonPageProps> = (props: PersonPageProps) => {
  const dispatch = PersonalFormStore.dispatch;
  const callbackListen = (): void => {
    dispatch(backInitialState());
  };

  Listen({ event: Events.NAME, type: Types.NAME, callback: callbackListen });

  return (
    <Provider store={PersonalFormStore}>
      <TrackingProvider value={tracking}>
        <ThemeProvider theme={{ ...tokens }}>
          <PersonalInfo {...props} />
          <Messages />
        </ThemeProvider>
      </TrackingProvider>
    </Provider>
  );
};

export default mfPersonPage;
